import { IconButton } from '@/layouts/authenticated/components/top-navigation/components/icon-button';
import { useCommandDialog } from '@/features/command-dialog';
import { useAnalytics } from '@/services/analytics';
import { KeyboardShortcut, InlineStack } from '@customerio/pluma-components/react';

export function CommandDialogButton() {
  const commandDialog = useCommandDialog();
  const { track } = useAnalytics();

  const handleClick = () => {
    void track('commandDialog', 'opened', { 'Entry Point': 'header' });
    commandDialog.toggle();
  };

  return (
    <IconButton
      icon="search"
      label="Search"
      tooltip={
        commandDialog.isOpen ? undefined : (
          <InlineStack gap="100" alignBlock="center">
            <span>Search</span>
            <KeyboardShortcut hotkey="Mod+K" isInverted />
          </InlineStack>
        )
      }
      onClick={handleClick}
      isDisabled={commandDialog.isOpen}
    />
  );
}
